<template>
  <div>
    <!-- <div>book lab test page </div> -->
    <div id="wrapper" class="col-md-10 mr-auto ml-auto" style="height:calc(100vh - 47px);overflow:scroll;">

      <!-- Lab tests -->
      <transition enter-active-class="slideInUp">
        <card v-if="PATIENT_SELECTED && LAB_DETAILS_ENTERED" id="labtests-card">
          <div slot="header">
            <div class="row">
              <div class="col-8">
                <h4 slot="header" class="card-title">
                  {{ $t("message.Lab Tests") }}
                </h4>
              </div>
            </div>
          </div>
          <div v-if="laborder.labTests">
            <div v-for="(labtest, index) in laborder.labTests" :key="labtest._id" class="labtest-card">
              <card>
                <div class="col-10 col-md-10 col-lg-10 pr-0">
                  <p>{{ labtest.name }}</p>
                  <p v-if="labtest.billingDetails">
                    <i :class="getCurrencyClass(labtest.billingDetails.currency)"></i>
                    <span> {{ labtest.billingDetails.amount }}</span>
                  </p>
                </div>
                <div class="col-2 col-md-2 col-lg-2" style="color: red;position: absolute;inset-inline-end: 1em;" @click="deleteLabtest(index)">
                  <i class="el-icon-delete"></i>
                </div>
              </card>
            </div>
          </div>
          <div class="col-md-12 text-center">
            <n-button type="primary" simple round @click.native="addNewLabtest()">
              <i class="fa fa-plus pr-1"></i>
              {{ (laborder.labTests.length > 0) ?  $t("message.Additional lab test") : $t("message.Add Lab Test") }}
            </n-button>
          </div>
          <div class="col-12 text-center" v-if="laborder.labTests && laborder.labTests.length > 0">
            <n-button type="primary" round @click.native="labTestSelectionDone()" v-if="!LABTESTS_SELECTED">
              <h6 class="m-0">{{ $t("message.Next") }}</h6>
            </n-button>
          </div>

          <div class="col-12 text-center" v-if="LABTESTS_SELECTED">
            <check-mark-svg></check-mark-svg>
          </div>
        </card>
      </transition>

      <!-- Sample collection data -->
      <transition enter-active-class="slideInUp">
        <card v-if="PATIENT_SELECTED && LABTESTS_SELECTED && LAB_DETAILS_ENTERED" id="sample-collection-location">
          <div slot="header">
            <div class="row">
              <div class="col-12">
                <h4 slot="header" class="card-title">
                  {{ 'Sample Collection Details' }}
                </h4>
              </div>
            </div>
          </div>

          <!-- Sample collection location -->
          <div class="">
            <div class="row mb-2 align-items-center">
              <div class="col-6">
                <h6 class="mb-0">Address</h6>
              </div>
              <div class="col-6 text-right" v-if="SAMPLE_LOCATION_SELECTED">
                <!-- <i class="fa fa-edit text-muted" style="font-weight: 100" @click="resetLocationSelection()"></i> -->
                <n-button type="primary" style="font-size: 0.8em; padding: 0.4em; margin: auto;" simple round @click.native="resetLocationSelection()">
                  <span class="m-0">Change Address</span>
                </n-button>
              </div>
            </div>
            <div class="row">
              <div class="col-12 text-center">
                <div class="col-md-12" v-if="SAMPLE_LOCATION_SELECTED">
                  <p v-if="laborder.sampleCollectionLocation.address">{{laborder.sampleCollectionLocation.address}}</p>
                  <p>{{laborder.sampleCollectionLocation.geolocation.landmark}}</p>
                </div>
                <!-- <check-mark-svg v-if="SAMPLE_LOCATION_SELECTED"></check-mark-svg> -->
              </div>

            </div>

            <!-- manual location input -->
            <div v-show="!SAMPLE_LOCATION_SELECTED">
              <div class="row">
                <div class="col-md-12">
                  <fg-input>
                    <textarea class="form-control" name="sample-location" :placeholder="$t('message.Enter Address')" v-model="laborder.sampleCollectionLocation.address"></textarea>
                  </fg-input>
                </div>
              </div>

              <div class="row" v-show="!GEO_LOCATION_CLEARED">
                <div class="col-md-12">
                  <label for="geolocation-landmark" class="ml-3">{{ $t("message.Landmark") }}</label>
                  <card>
                    <div class="col-10 col-md-10 col-lg-10" v-if="laborder.sampleCollectionLocation.geolocation">
                      <p>{{laborder.sampleCollectionLocation.geolocation.landmark}}</p>
                    </div>
                    <div class="col-2 col-md-2 col-lg-2" style="position: absolute;inset-inline-end: -0.1em;top: 0.1em;font-size: 2em;" @click="clearGeolocation()">
                      <i class="el-icon-close text-muted"></i>
                    </div>
                  </card>
                </div>
              </div>
              <!-- google location search -->
              <div class="row" v-show="GEO_LOCATION_CLEARED">
                <div class="col-md-12">
                  <vue-google-autocomplete ref="landmarkLocation" id="location-input" classname="form-control" :placeholder="$t('message.Search landmark')" v-on:placechanged="getAddressData" types="" country="in">
                  </vue-google-autocomplete>
                </div>
              </div>

              <div class="row justify-content-center mt-2">
                <n-button type="primary" simple round style="margin-left: 1em;" @click.native="setSampleCollectionAddress()">
                  <span class="m-0">Reset Address</span>
                </n-button>
              </div>
            </div>
          </div>

          <hr class="mb-4">

          <!-- Sample collection time -->
          <div class="">
            <div class="row mb-2">
              <div class="col-10">
                <h6>Time</h6>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <vue-datetime v-model="sampleCollectionTime" type="datetime" format="dd-MM-yyyy, hh:mm a" :placeholder="$t('message.Select Date and Time')" :minute-step="15" :min-datetime="new Date().toISOString()" :auto="true" :use12-hour="true" :backdrop-click="false" :phrases="{ok:$t('message.OK'), cancel: $t('message.Cancel')}" input-class="form-control"></vue-datetime>
              </div>
            </div>

            <div class="row mt-4" style="font-size: 0.8em;">
              <div class="col-12">
                <span>* Above details will be considered if sample collection at home is possible</span>
              </div>
            </div>

            <div class="row">
              <div class="col-12 text-center">
                <n-button type="primary" round @click.native="setSampleCollectionDetails()" v-if="(!COLLECTION_TIME_SELECTED || !SAMPLE_LOCATION_SELECTED)">
                  <h6 class="m-0">{{ $t("message.Next") }}</h6>
                </n-button>
              </div>
              <div class="col-12 text-center" v-if="COLLECTION_TIME_SELECTED && SAMPLE_LOCATION_SELECTED">
                <check-mark-svg></check-mark-svg>
              </div>
            </div>
          </div>

        </card>
      </transition>

      <!-- Sample collection time -->
      <!-- <transition enter-active-class="slideInUp">
        <card v-if="PATIENT_SELECTED && LABTESTS_SELECTED &&  LAB_DETAILS_ENTERED && SAMPLE_LOCATION_SELECTED" id="sample-collection-time">
          <div slot="header">
            <div class="row">
              <div class="col-10">
                <h4 slot="header" class="card-title">
                  {{ $t("message.Sample Collection Time") }}
                </h4>
              </div>
            </div>
          </div>

          <div class="col-12 text-center" v-if="COLLECTION_TIME_SELECTED">
            <check-mark-svg></check-mark-svg>
          </div>
        </card>
      </transition> -->

      <!-- Payments -->
      <transition enter-active-class="slideInUp">
        <card v-if="PATIENT_SELECTED && LABTESTS_SELECTED &&  SHOW_PAYMENT_GATEWAY" id="payments-card">
          <h4 slot="header" class="card-title">
            {{ $t("message.Payment") }}
          </h4>
          <n-table :columns="['Test','Amount']" :data="paymentBreakupData"></n-table>
          <div class="mb-2  mt-4 text-center" style="font-size: x-large" id="payments-div">
            <div style="
                color: grey;
                border-radius: 10%;
                text-decoration: line-through;
              " v-if="actualAmount && (actualAmount != amount)" class="pl-2">
              <i :class="getCurrencyClass(laborder.labTests[0].billingDetails.currency)"></i>
              <span v-if="actualAmount && (actualAmount != amount)">{{ actualAmount }}</span>
            </div>

            <div>
              <div style="color: grey; border-radius: 10%" class="pl-2 text-primary">
                <i :class="getCurrencyClass(laborder.labTests[0].billingDetails.currency)"></i>
                <span>{{ amount }}</span>
              </div>
              <h3 class="card-category">
                {{ $t("message.Total amount to be paid") }}
              </h3>
            </div>
          </div>

          <div class="row" v-if="SHOW_COUPON_ENTRY && (amount != 0)">
            <div class="col-12 col-md-6 offset-md-3">
              <fg-input class="form-control-lg" name="coupon-code" :placeholder="$t('message.Coupon Code')" v-model="couponCode" onkeyup="this.value = this.value.toUpperCase();" @click.native="IS_COUPON_CODE_ERR = null" :disabled="COUPON_CODE_APPLIED"></fg-input>
              <n-button type="primary" round style="position: absolute; top: -9px; inset-inline-end: 15px; height: 46px" @click.native="applyCoupon()" v-if="this.couponCode && !COUPON_CODE_APPLIED">
                <h6 class="m-0">{{ $t("message.Apply") }}</h6>
              </n-button>
              <n-button type="danger" round style="position: absolute; top: -9px; inset-inline-end: 15px; height: 46px" v-if="COUPON_CODE_APPLIED" @click.native="removeCoupon()">
                <h6 class="m-0">{{ $t("message.Remove") }}</h6>
              </n-button>
            </div>
            <div class="col-12 col-md-6 offset-md-3">
              <span class="text-danger pt-1" v-if="IS_COUPON_CODE_ERR">{{
                couponErrorMessage
              }}</span>

              <span class="text-success pt-1" v-if="COUPON_CODE_APPLIED">
                {{ $t("message.Coupon applied successfully You saved") }}
                <i :class="getCurrencyClass(laborder.labTests[0].billingDetails.currency)"></i>
                {{
                 actualAmount -amount
                }}
              </span>
            </div>
          </div>

          <div id="payment-card-buttons">
            <div class="col-12 text-center" v-if="amount  != 0">
              <div class="col-12 col-lg-12" v-if="settings">
                <div class="card-stats justify-content-center">
                  <n-button v-if="settings.paymentPreferences.labOrders.razorpay.enabled || settings.paymentPreferences.labOrders.paytm.enabled || settings.paymentPreferences.labOrders.khalti.enabled" type="primary" @click.native="initiatePayment()" round>
                    <span class="pr-2">{{ $t("message.PAY") }}</span>
                    <i :class="getCurrencyClass(laborder.labTests[0].billingDetails.currency)" style="padding-right: 0.2em;"></i>
                    <span>{{ amount }}</span>
                  </n-button>
                </div>
              </div>
            </div>

            <div class="row" v-if="amount == 0">
              <div class="col-12 text-center">
                <n-button type="primary" round @click.native="createLabOrder('Created')">
                  <h6 class="m-0">{{ $t("message.Create Lab Order") }}</h6>
                </n-button>
              </div>
            </div>
          </div>
        </card>
      </transition>

      <transition enter-active-class="slideInUp">
        <div class="col-12 text-center" v-if="PATIENT_SELECTED && LABTESTS_SELECTED &&  LAB_DETAILS_ENTERED && !BILLING_ENABLED">
          <n-button type="primary" round size="lg" @click.native="createLabOrder('Created')" id="btn-start-consulting">
            <h6 class="m-0">
              {{ $t("message.Create Lab Order")}}
            </h6>
          </n-button>
        </div>
      </transition>

    </div>

    <!-- Lab Tests selction modal-->
    <modal :show.sync="SHOW_LABTEST_SELECTION_MODAL" headerclasses="justify-content-center" modalClasses="h-100 m-0" modalContentClasses="h-100" bodyClasses="pt-2 bg-white" footerClasses="bg-white" @close="onLabTestSelectionModalClosed()">
      <h6 slot="header" class="title title-up">{{$t("message.Select Lab Test")}}</h6>
      <div class="row" v-if="!selectedLabTest">
        <div class="col-12 pl-5 pr-5">
          <cool-select class="custom-input" :placeholder="$t('message.Search Lab Tests')" :items="labTests" disable-filtering-by-search @select="selectLabTests" @search="searchLabtest" item-value="name" item-text="name" ref="lab-autocomplete" :search-text.sync="labtestSearchText">
            <template #no-data>
              <div class="text-center">
                <span v-show="labtestSearchText">
                  {{"Lab test not found"}}
                </span>
              </div>
            </template>
            <template slot="item" slot-scope="{ item }">
              <div class="row">
                <div class="pr-1 col-11 autocomplete-result">
                  <span class="item-name">{{ item.name }}</span>
                </div>
                <div class="pl-0 col-1 autocomplete-result" style="color: #616060;display: flex;justify-content: center;align-items: center;">
                  <i class="now-ui-icons arrows-1_minimal-right"></i>
                </div>
              </div>
            </template>
          </cool-select>
        </div>
      </div>
      <div class="row pl-3 pr-3" v-if="selectedLabTest">
        <div class="col-12">
          <card>
            <div class="row">
              <div class="col-10 pr-0">
                <div>
                  {{selectedLabTest.name}}
                </div>
                <div v-if="selectedLabTest.description">
                  {{selectedLabTest.description}}
                </div>
                <div v-if="selectedLabTest.billingDetails && selectedLabTest.billingDetails.amount">
                  <i :class="getCurrencyClass(selectedLabTest.billingDetails.currency)"></i>
                  {{selectedLabTest.billingDetails.amount}}
                </div>
              </div>
              <div class="col-2">
                <n-button type="danger" size="sm" class="mt-0" social icon round @click.native="deleteSelectedLabtest()">
                  <i slot="label" class="now-ui-icons ui-1_simple-remove"></i>
                </n-button>
              </div>
            </div>
          </card>
        </div>
      </div>
      <template slot="footer">
        <div v-if="selectedLabTest" class="text-center" style="width: 100%;">
          <n-button type="primary" round @click.native="selectLabtest(selectedLabTest)">
            <i class="fa fa-check pr-1"></i>{{ $t("message.Add") }}
          </n-button>
        </div>
      </template>
    </modal>
  </div>
</template>

<script>
export default {
  data() {
    return {
      laborder: {
        patient: {
          mobileNumber: "",
        },
        labTests: [],
        status: [],
        sampleCollectionLocation: {},
      },
      patientAgeYears: null,
      patientAgeMonths: null,
      PATIENT_SELECTED: false,
      SHOW_LABTEST_SELECTION_MODAL: true,
      LAB_DETAILS_ENTERED: false,

      // labtests
      selectedLab: null,
      labtestSearchText: null,
      labTests: [],
      selectedLabTest: null,
      LABTESTS_SELECTED: false,

      SAMPLE_LOCATION_SELECTED: false,
      SHOW_PAYMENT_GATEWAY: false,
      COLLECTION_TIME_SELECTED: false,
      GEO_LOCATION_CLEARED: true,

      COLLECTION_TIME_SELECTED: false,

      sampleCollectionTime: "",
    };
  },

  async mounted() {
    try {
      // select patient from logged in user
      this.selectPatient(this.user);
      await this.setSampleCollectionAddress();

      // selecting lab
      this.selectedLab = (
        await this.$store.dispatch("getAllLabEndpoints")
      ).data[0];
      this.LAB_DETAILS_ENTERED = true;
      this.laborder.lab = this.selectedLab.name;
      this.laborder.sampleCollectionHome = true;
    } catch (error) {
      console.error(error);
    }
  },

  methods: {
    deleteLabtest(index) {
      this.laborder.labTests.splice(index, 1);
      this.getPaymentBreakupData();
      if (this.laborder.labTests && this.laborder.labTests.length > 0) {
        this.getTotalAmount();
      } else {
        this.LABTESTS_SELECTED = false;
      }
    },
    deleteSelectedLabtest() {
      this.selectedLabTest = null;
    },
    async setSampleCollectionAddress() {
      if (typeof this.user.endpoint == "string") {
        await this.$store.dispatch("getEndpoint", this.user.endpoint);
      } else {
        await this.$store.dispatch("getEndpoint", this.user.endpoint.name);
      }
      if (
        this.endpoint &&
        this.endpoint.location &&
        this.endpoint.location.addressDetails &&
        this.endpoint.location.addressDetails.geolocation
      ) {
        this.laborder.sampleCollectionLocation.geolocation = {
          landmark: this.endpoint.location.addressDetails.address,
          coordinates:
            this.endpoint.location.addressDetails.geolocation.coordinates,
        };

        this.SAMPLE_LOCATION_SELECTED = true;
      } else {
        this.GEO_LOCATION_CLEARED = true;
      }
      if (this.$refs.landmarkLocation) {
        this.$refs.landmarkLocation.clear();
      }
      this.laborder.sampleCollectionLocation.address = "";
    },

    selectPatient(patient) {
      //Clear mobile number field
      this.laborder.patient.patientId = patient.patientId;
      this.laborder.patient.firstName = patient.firstName;
      this.laborder.patient.lastName = patient.lastName;

      var m = moment(patient.dob);
      var years = moment().diff(m, "years", false);
      this.patientAgeYears = years;
      m = moment(m).add(years, "years");
      this.patientAgeMonths = moment().diff(m, "months", false);

      this.laborder.patient.gender = patient.gender;
      this.laborder.patient.history = patient.history;
      this.laborder.patient.email = patient.email;
      this.laborder.patient.mobileNumber =
        patient.mobileNumber && patient.mobileNumber.replace(/ /g, "");

      if (this.laborder.patient.mobileNumber) {
        this.mobileNumber = this.laborder.patient.mobileNumber;
      }
      this.laborder.patient.additionalInfo = patient.additionalDetails
        ? patient.additionalDetails
        : {};
      this.laborder.patient.provider = patient.provider;
      if (this.error) this.error = "";
      this.PATIENT_SELECTED = true;
      // this.getLabPrescriptions();
    },

    calculateDob() {
      let currentYear = new Date().getUTCFullYear();
      let yearOFBirth = currentYear - (this.patientAgeYears || 0);

      let currentMonth = new Date().getMonth() + 1;
      let monthOfBirth = currentMonth - (this.patientAgeMonths || 0);

      if (monthOfBirth == 0 || Math.sign(monthOfBirth) == -1) {
        --yearOFBirth;
        monthOfBirth = 12 + monthOfBirth;
      }
      this.laborder.patient.dob = monthOfBirth + "/01/" + yearOFBirth;
    },

    // labtest selection
    async searchLabtest() {
      if (this.labtestSearchText.length > 0) {
        try {
          this.labTests = await this.$store.dispatch("searchLabtests", {
            searchText: this.labtestSearchText,
            lab: this.selectedLab.name,
          });
        } catch (e) {
          this.labTests = [];
          console.log(e);
        }
      } else {
        this.labTests = [];
      }
    },
    addNewLabtest() {
      this.SHOW_LABTEST_SELECTION_MODAL = true;
    },
    labTestSelectionDone() {
      this.LABTESTS_SELECTED = true;
      if (
        this.laborder.sampleCollectionLocation.geolocation &&
        this.laborder.sampleCollectionLocation.geolocation.landmark &&
        this.laborder.sampleCollectionLocation.geolocation.coordinates.length >
          0
      ) {
        this.SAMPLE_LOCATION_SELECTED = true;
      }
      this.getPaymentBreakupData();
      setTimeout(() => {
        this.scrollTo("wrapper");
      }, 500);
    },

    selectLabTests(labTest) {
      this.selectedLabTest = labTest;
    },
    selectLabtest(labtest) {
      this.laborder.labTests.push(labtest);
      this.labTests = [];
      this.labtestSearchText = null;
      this.setLabtestBillingDetails();
      this.getPaymentBreakupData();
      this.getTotalAmount();
      this.onLabTestSelectionModalClosed();
      this.$forceUpdate();
    },

    setLabtestBillingDetails() {
      //Setting labtests billing details
      if (this.selectedLab) {
        if (this.laborder.labTests && this.laborder.labTests.length > 0) {
          let avialableLabtests = [];
          let notAvialableLabtests = [];
          //Checking avialable and not avialable labtests for selected lab based on billing details
          this.laborder.labTests.forEach((labtest) => {
            if (labtest && labtest.endpoints.length > 0) {
              let endpointName = this.tenant + this.selectedLab.name;
              let endpoint = labtest.endpoints.find(
                (ep) => ep.endpoint == endpointName
              );

              if (
                endpoint &&
                endpoint.billingDetails &&
                Number(endpoint.billingDetails.amount) > 0
              ) {
                labtest.billingDetails = endpoint.billingDetails;
                avialableLabtests.push(labtest);
              } else {
                notAvialableLabtests.push(labtest.name);
              }
            } else {
              notAvialableLabtests.push(labtest.name);
            }
          });

          if (notAvialableLabtests && notAvialableLabtests.length > 0) {
            let text =
              "<ul style='list-style-type: square;text-align:left;margin-top: 1rem;'>";
            notAvialableLabtests.forEach((test) => {
              text =
                text +
                "<li><span style='font-size: 0.7em;font-weight: 400'>" +
                test +
                "</span></li>";
            });
            text = text + "</ul";

            swal
              .fire({
                title: this.$t("message.Following tests are not avialable"),
                html: text,
                confirmButtonText: this.$t("message.Continue"),
                showCancelButton: true,
                cancelButtonText: this.$t("message.Change Lab"),
              })
              .then((result) => {
                if (result && result.value) {
                  this.laborder.labTests = avialableLabtests;
                  this.getTotalAmount();
                  if (!this.LAB_DETAILS_ENTERED) {
                    this.LAB_DETAILS_ENTERED = true;
                    this.stepper.completed += 1;
                  }
                  this.$forceUpdate();
                } else {
                  this.resetLabDetails();
                }
              });
          } else {
            this.laborder.labTests = avialableLabtests;
            this.getTotalAmount();
            if (!this.LAB_DETAILS_ENTERED) {
              this.LAB_DETAILS_ENTERED = true;
            }
          }
        }
      }
    },

    getPaymentBreakupData() {
      if (this.laborder.labTests) {
        this.paymentBreakupData = [];
        this.laborder.labTests.forEach((labtest) => {
          if (labtest.billingDetails) {
            this.paymentBreakupData.push({
              test: labtest.name,
              amount: labtest.billingDetails.amount,
            });
          }
        });
      }
    },

    getTotalAmount() {
      let total = 0;
      this.laborder.labTests.forEach((labtest) => {
        if (labtest.billingDetails) {
          total = total + Number(labtest.billingDetails.amount);
        }
      });
      this.amount = total;
    },

    onLabTestSelectionModalClosed() {
      this.SHOW_LABTEST_SELECTION_MODAL = false;
      this.selectedLabTest = null;
      this.labtestSearchText = null;
    },

    setSampleCollectionDetails() {
      this.setSampleLocationAdress();
      this.collectionTimeSelected();
    },

    setSampleLocationAdress() {
      if (
        this.laborder.sampleCollectionLocation.geolocation &&
        this.laborder.sampleCollectionLocation.geolocation.landmark &&
        this.laborder.sampleCollectionLocation.geolocation.coordinates.length >
          0
      ) {
        this.SAMPLE_LOCATION_SELECTED = true;
        // this.stepper.completed += 1;
        if (this.COLLECTION_TIME_SELECTED) {
          // this.stepper.completed += 1;
          this.SHOW_PAYMENT_GATEWAY = true;
          setTimeout(() => {
            this.scrollTo("wrapper");
          }, 500);
        }
      } else {
        swal.fire(this.$t("message.Please select Land mark"));
      }
    },

    resetLocationSelection() {
      this.SHOW_PAYMENT_GATEWAY = false;
      this.SAMPLE_LOCATION_SELECTED = false;
      this.laborder.sampleCollectionLocation.address = "";
      this.clearGeolocation();
      // this.stepper.completed = 3;
    },

    clearGeolocation() {
      this.laborder.sampleCollectionLocation.geolocation = {
        landmark: "",
        coordinates: [],
      };
      if (this.$refs.landmarkLocation) {
        this.$refs.landmarkLocation.clear();
      }
      this.GEO_LOCATION_CLEARED = true;
    },

    getAddressData(addressData, placeResultData, id) {
      let coordinates = [addressData.longitude, addressData.latitude];
      this.laborder.sampleCollectionLocation.geolocation = {
        landmark: placeResultData.formatted_address,
        coordinates: coordinates,
      };
      this.GEO_LOCATION_CLEARED = false;
    },

    collectionTimeSelected() {
      if (this.sampleCollectionTime) {
        this.COLLECTION_TIME_SELECTED = true;
        // this.stepper.completed += 1;
        if (this.BILLING_ENABLED) {
          this.SHOW_PAYMENT_GATEWAY = true;
          this.getPaymentBreakupData();
        }
        setTimeout(() => {
          this.scrollTo("wrapper");
        }, 500);
      } else {
        swal.fire(this.$t("message.Please select sample collection time"));
      }
    },

    async createLabOrder(status) {
      try {
        let that = this;
        this.laborder.status.push({
          status: status,
          updatedBy: this.user.username,
          timestamp: new Date().getTime(),
        });
        this.laborder.latestStatus = status;
        this.laborder.createdBy = "patient";
        this.laborder.endpoint = this.endpoint.name;
        this.laborder.createdUser = this.user._id;

        //Saving epoch string for Sample Collection time
        if (this.sampleCollectionTime) {
          this.laborder.sampleCollectionTime = new Date(
            this.sampleCollectionTime
          ).getTime();
        }

        if (
          status == "Created" &&
          this.COUPON_CODE_APPLIED &&
          this.amount == 0
        ) {
          let currency = this.laborder.labTests[0].billingDetails.currency;
          this.laborder.billingDetails = {
            paid: true,
            amount: this.amount,
            currency: currency,
            actualAmount: this.actualAmount,
            couponCode: this.appliedCouponCode,
          };
        }

        //Setting billing details if billing is enabled
        if (status == "Blocked") {
          let currency = this.laborder.labTests[0].billingDetails.currency;
          this.laborder.billingDetails = {
            amount: this.amount,
            currency: currency,
          };
          if (this.COUPON_CODE_APPLIED) {
            this.laborder.billingDetails.actualAmount = this.actualAmount;
            this.laborder.billingDetails.couponCode = this.appliedCouponCode;
          }
        }
        let response = await this.$store.dispatch(
          "createLabOrder",
          this.laborder
        );
        this.laborder = response;
        if (status == "Created") {
          // this.stepper.completed += 1;
          swal
            .fire({
              title: this.$t("message.Lab Order created successfully!"),
              type: "success",
            })
            .then(() => {
              that.$router.back();
            });
        }
      } catch (e) {
        console.log(e);
      }
    },

    async initiatePayment() {
      //create lab order with blocked status
      await this.createLabOrder("Blocked");

      if (
        this.settings.paymentSettings.razorpay.enabled &&
        this.settings.paymentPreferences.labOrders.razorpay.enabled &&
        RazorpayCheckout
      ) {
        this.initiateRazorPayPayment();
      }
    },

    async initiateRazorPayPayment() {
      let that = this;
      this.PAYMENT_INPROGRESS = true;
      let transaction = await this.$store.dispatch("initiateLabOrderPayment", {
        gateway: "razorpay",
        laborderId: this.laborder._id,
        patient: this.patient,
      });

      var options = {
        order_id: transaction.paymentDetails.orderId,
        description: this.settings.paymentSettings.razorpay.paymentDescription,
        key: this.settings.paymentSettings.razorpay.key_id,
        currency: transaction.paymentDetails.currency,
        amount: Number(transaction.paymentDetails.amount) * 100 + "",
        name: this.settings.paymentSettings.razorpay.name,
        image: "https://i.imgur.com/n5tjHFD.png",
        prefill: {
          name:
            this.laborder.patient.firstName +
            " " +
            this.laborder.patient.lastName,
          email:
            this.laborder.patient.email ||
            this.settings.directBookings.defaultEmail ||
            "",
          contact: this.laborder.patient.mobileNumber,
        },
        theme: {
          color:
            document.documentElement.style.getPropertyValue(
              "--color-primary"
            ) || "#f96332",
        },
      };

      if (this.settings.paymentSettings.razorpay.logoUrl) {
        options.image = this.settings.paymentSettings.razorpay.logoUrl;
      }

      window.razorpaySuccessCallback = async function (response) {
        response.laborderId = that.laborder._id;
        response.razorpay_order_id = transaction.paymentDetails.orderId;
        try {
          let verificationResponse = await that.$store.dispatch(
            "verifyLabOrderPayment",
            {
              gateway: "razorpay",
              transaction: response,
            }
          );

          if (
            verificationResponse &&
            verificationResponse.latestStatus == "Success"
          ) {
            //Confirm lab order after payment success
            that.laborder = await that.$store.dispatch("updateLabOrderStatus", {
              laborderId: that.laborder._id,
              status: "Created",
            });

            swal
              .fire({
                type: "success",
                title: that.$t("message.Payment successful!"),
                text: that.$t("message.Lab Order created successfully!"),
              })
              .then(() => {
                that.$router.push({
                  path: "/viewpatientlaborders",
                });
              });
          } else {
            throw new Error("Payment failed");
          }
        } catch (e) {
          console.log(e);
          swal.fire({
            type: "error",
            title: that.$t("message.Payment failed!"),
            text: that.$t("message.Any consultation fees paid will be refunded within 7 working days"),
            timer: 5000,
          });
        }
      };

      window.razorpayCancelCallback = function (error) {
        console.log(error);
        swal
          .fire({
            type: "error",
            title: that.$t("message.Payment failed!"),
            text: that.$t("message.Any consultation fees paid will be refunded within 7 working days"),
            timer: 5000,
          })
          .then(() => {
            that.$router.push("/nursehome");
          });
      };

      RazorpayCheckout.on("payment.success", window.razorpaySuccessCallback);
      RazorpayCheckout.on("payment.cancel", window.razorpaySuccessCallback);
      RazorpayCheckout.open(options);
    },
  },

  watch: {
    patientAgeYears: function () {
      this.calculateDob();
    },
    patientAgeMonths: function () {
      this.calculateDob();
    },
  },

  computed: {
    user() {
      if (localStorage.user) {
        return JSON.parse(localStorage.user);
      }
    },
    settings() {
      return this.$store.state.settings;
    },
    BILLING_ENABLED() {
      return this.settings.billingEnabled;
    },
    tenant() {
      return this.settings.tenant;
    },
    endpoint() {
      return this.$store.state.endpoint;
    },
  },
};
</script>

<style scoped>
/deep/ .labtest-card .card-body {
  display: flex;
}

/deep/.modal-content .modal-header {
  padding-bottom: 1em;
}

.autocomplete-result {
  margin-top: 1em;
  margin-bottom: 1em;
}

/deep/ .modal-content .modal-body {
  padding-left: 0px;
  padding-right: 0px;
}

/deep/ .modal-dialog {
  max-width: inherit;
}
</style>
